<h2 mat-dialog-title>Enter report values</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="parameter-form">
    <div class="parameter-row" *ngFor="let control of controls">
      <mat-form-field appearance="outline" *ngIf="control.finiteOptionSource && !control.multiple">
        <mat-label>{{ control.label }}</mat-label>
        <mat-select [formControlName]="control.key">
          <mat-option *ngFor="let option of control.options" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="control.finiteOptionSource && control.multiple">
        <mat-label>{{ control.label }}</mat-label>
        <mat-select multiple [formControlName]="control.key">
          <mat-option *ngFor="let option of control.options" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="!control.finiteOptionSource && control.type !== 'boolean' && !control.multiple">
        <mat-label>{{ control.label }}</mat-label>
        <input matInput [type]="control.type === 'number' ? 'number' : control.type === 'date' ? 'date' : control.type === 'datetime' ? 'datetime-local' : 'text'" [formControlName]="control.key" />
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="!control.finiteOptionSource && control.multiple">
        <mat-label>{{ control.label }}</mat-label>
        <textarea matInput rows="3" [formControlName]="control.key"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="!control.finiteOptionSource && control.type === 'boolean'">
        <mat-label>{{ control.label }}</mat-label>
        <mat-select [formControlName]="control.key">
          <mat-option value="true">True</mat-option>
          <mat-option value="false">False</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="submit()">Run report</button>
</mat-dialog-actions>
